import moment from "moment";
import { LoadingOutlined } from "@ant-design/icons";

export const getChain = (values, all) => {
  values.forEach(s => {
    all.push(s)
    if (Array.isArray(s.childrens) && s.childrens.length) { getChain(s.childrens, all) }
  })
  return all;
}

export const getConfig = ({ loading, t, projectData, data }) => [
  {
    key: 'dataPoints',
    title: t('Total Data Points'),
    render: () => loading ? <LoadingOutlined size="small" />
      : data ? Number(data.totalDatapoints || 0).toLocaleString("en-US") : 0
  },
  {
    key: 'subjects',
    title: t('Subjects Identified'),
    render: () => loading ? <LoadingOutlined size="small" />
      : data ? Number(data.subjectsIdentified || 0).toLocaleString("en-US") : 0
  },
  {
    key: 'dateCreated',
    title: t('Date Created'),
    render: () => (projectData && !loading) ?
      moment(projectData.createdAt).format('DD MMM YY')
      : <LoadingOutlined />
  },
  {
    key: 'lastUpdated',
    title: t('Last Updated'),
    render: () => (projectData && !loading) ?
      moment(projectData.publishedAt).format('DD MMM YY')
      : <LoadingOutlined />,
  },
  {
    key: 'infoSources',
    title: t('Information Sources'),
    render: () => {
      if (loading) {
        return <LoadingOutlined size="small" />;
      }
      const totalSources = getChain(
        data?.sourcesOfInformation && data?.sourcesOfInformation.ownData ?
          [data?.sourcesOfInformation.ownData] : [],
        []
      ).length;

      return (totalSources).toLocaleString("en-US")
    },
  },
  {
    key: 'informationClients',
    title: t('Information Clients'),
    render: () => {
      if (loading) {
        return <LoadingOutlined size="small" />;
      }
      const total = getChain(
        data?.projectInformationClients && data?.projectInformationClients.ownData ?
          [data?.projectInformationClients.ownData] : [],
        []
      ).length;

      return (total - 1).toLocaleString("en-US")
    },
  },
];
